import { useState } from "react";
import { X } from "lucide-react";

export default function TagInput({ tags, setTags }) {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      if (!tags.includes(inputValue.trim())) {
        setTags([...tags, inputValue.trim()]);
      }
      setInputValue("");
    }
  };

  const removeTag = (index) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  return (
    <div className="max-w-sm">
      <label className="block text-sm font-medium text-black mb-1">
        Placeholder
      </label>
      <div className="flex flex-wrap items-center gap-2 p-2 bg-gray-50 border border-[#0000003D] rounded-[10px]">
        {tags.map((tag, index) => (
          <div
            key={index}
            className="flex items-center bg-[#ECEBEB] text-sm text-black px-3 py-[2px] rounded-lg shadow-sm"
          >
            {tag}
            <div
              onClick={() => removeTag(index)}
              className="ml-2 text-black hover:text-red-500"
            >
              <X size={16} />
            </div>
          </div>
        ))}
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-grow min-w-[100px]  bg-[#FAFAFA] h-[28px] !focus:outline-none text-sm text-black"
          placeholder="Type & press Enter"
        />
      </div>
    </div>
  );
}
